import axios from 'axios';

const state = {
    settings: null,
    donations: [],
    stats: null,
};

const getters = {
    settings: state => state.settings,
    donations: state => state.donations,
    stats: state => state.stats,
};

const actions = {
    donation_get_settings(_, shopId) {
        return axios.get('shops/' + shopId + '/donation/settings');
    },
    donation_update_settings(_, { shopId, settings }) {
        return axios.put('shops/' + shopId + '/donation/settings', settings);
    },
    donation_list(_, { shopId, params }) {
        return axios.get('shops/' + shopId + '/donations', { params });
    },
    donation_stats(_, shopId) {
        return axios.get('shops/' + shopId + '/donation/stats');
    },
    donation_mark_paid(_, id) {
        return axios.put('shop/donation/' + id + '/mark-paid');
    },
};

const mutations = {
    SET_SETTINGS(state, s) { state.settings = s; },
    SET_DONATIONS(state, d) { state.donations = d; },
    SET_STATS(state, s) { state.stats = s; },
};

export default { namespaced: true, state, getters, actions, mutations };
